import { render, staticRenderFns } from "./RashodnayaNakladnayaList.vue?vue&type=template&id=08b67b1a&"
import script from "./RashodnayaNakladnayaList.vue?vue&type=script&lang=js&"
export * from "./RashodnayaNakladnayaList.vue?vue&type=script&lang=js&"
import style0 from "./RashodnayaNakladnayaList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VDivider,VFlex,VLayout})
